import React from "react";
import img from "../../images/not-found.png";

const NotFound = () => {
  return (
    <div className="d-flex justify-content-center">
      <img src={img} alt="" />
    </div>
  );
};

export default NotFound;
